import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerReportsModule } from '../../../features/customer-reports/customer-reports.module';
import { CustomerReportsPgsRoutingModule } from './utility-bills-dashboard-pgs-routing.module';
import { UtilityBillsDashboardPgComponent } from './utility-bills-dashboard-pg/utility-bills-dashboard-pg';
import { FlexModule } from '@angular/flex-layout';

import { 
  MatCardModule, 
  MatProgressSpinnerModule,
  MatGridListModule,
  MatIconModule
 } from '@angular/material';
import { PowerBiReportComponent } from '../powerbi-component/power-bi-report.component';

@NgModule({
  imports: [
    CommonModule,
    CustomerReportsPgsRoutingModule,
    CustomerReportsModule,
    MatCardModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    FlexModule
  ],
  declarations: [UtilityBillsDashboardPgComponent, PowerBiReportComponent]
})
export class UtilityBillsDashboardPgModule { }
